import { createReducer, on } from '@ngrx/store';
import { OutletGroups } from 'app/interfaces';
import {
  resetAdvancedSearchFilters,
  setAdvancedFilterText,
  setOutletGroups,
  unSetAdvancedFilterText,
} from 'redux/actions';

export interface AdvancedSearchState {
  onResetFilters: boolean;
  filterText: string;
  outletGroups: OutletGroups[];
}

const initialState: AdvancedSearchState = {
  onResetFilters: false,
  filterText: null,
  outletGroups: [],
};

const _advancedSearchReducer = createReducer(
  initialState,

  on(resetAdvancedSearchFilters, (state, { onResetFilters }) => {
    return {
      ...state,
      onResetFilters,
    };
  }),

  on(setAdvancedFilterText, (state, { filterText }) => {
    return {
      ...state,
      filterText,
    };
  }),
  on(unSetAdvancedFilterText, (state) => {
    return {
      ...state,
      filterText: null,
    };
  }),
  on(setOutletGroups, (state, { outletGroups }) => {
    return {
      ...state,
      outletGroups,
    };
  })
);

export function advancedSearchReducer(state, action) {
  return _advancedSearchReducer(state, action);
}
